// extracted by mini-css-extract-plugin
export default {"main":"FormInput_main__A0+Eo","label":"FormInput_label__bYP7E"};